import Alert from "./Alert";

const ErrorAlert = props => (
  <Alert severity="error" {...props}/> 
);

export default ErrorAlert;